import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import { ListeTable } from '@mairistem/liste';

import type { ArreteType } from '@/types';
import { formatMonetaire } from '@/utils';

import ArretesJournaliersDocumentPopup from './ArretesJournaliersDocumentPopup';

interface ArretesJournaliersListeTableRowProps {
  item: ArreteType;
  rowProps: Record<string, unknown>;
}

const ArretesJournaliersListeTableRow = (props: ArretesJournaliersListeTableRowProps) => {
  const { item, rowProps } = props;

  const { identifiant, date, libelle, montantTotal, montantTotalAnnulation, documents } = item;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="libelle"
        // @ts-expect-error
        title={libelle}
      >
        <div className="textEllipsis" style={{ paddingRight: 10 }}>
          {libelle}
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell name="date" textAlign="center" style={{ width: 150 }}>
        {dayjs(date).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell name="heure" textAlign="center" style={{ width: 100 }}>
        {dayjs(date).format('HH:mm')}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="montantTotal"
        textAlign="right"
        style={{ width: 140 }}
        // @ts-expect-error
        title={
          (!montantTotal || montantTotal === 0) &&
          montantTotalAnnulation &&
          montantTotalAnnulation > 0
            ? `La journée du ${dayjs(date).locale('fr').format('D MMMM YYYY')} est arrêtée sans encaissement. Des annulations de reçus ont été saisies pour un montant de ${formatMonetaire(montantTotalAnnulation, 2, true)}.`
            : undefined
        }
      >
        {formatMonetaire(montantTotal ?? 0)}
      </ListeTable.Cell>
      <ListeTable.Cell name="document" textAlign="center" style={{ width: 120 }}>
        <ArretesJournaliersDocumentPopup documents={documents} />
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ArretesJournaliersListeTableRow;
